export default __webpack_public_path__ + "static/match-group-light-mode-6c010f56d414f8ac08f3e37547ba0460.png";